import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import { NamedLink } from '../../../../components';

import css from './Hero.module.css';

const points = [
  {
    id: 'ForProvidersHero.visibility',
    defaultMessage: 'Be discovered by families searching for your specialty',
  },
  {
    id: 'ForProvidersHero.credibility',
    defaultMessage: 'A profile that reflects your credentials and care philosophy',
  },
  {
    id: 'ForProvidersHero.connections',
    defaultMessage: 'Direct connections, without agencies or algorithms',
  },
  {
    id: 'ForProvidersHero.autonomy',
    defaultMessage: 'Set your own rates, availability, and service area',
  },
];

/**
 * Opening section of the for-providers page.
 */
const Hero = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <div className={css.copy}>
        <p className={css.eyebrow}>
          <FormattedMessage
            id="ForProvidersHero.eyebrow"
            defaultMessage="For perinatal care professionals"
          />
        </p>
        <h1 className={css.title}>
          <FormattedMessage
            id="ForProvidersHero.title"
            defaultMessage="A better way for families to find you"
          />
        </h1>
        <p className={css.intro}>
          <FormattedMessage
            id="ForProvidersHero.intro"
            defaultMessage="PostPartners connects perinatal professionals with the families who need them."
          />
        </p>
        <div className={css.actions}>
          <NamedLink
            className={css.primary}
            name="SignupForUserTypePage"
            params={{ userType: 'provider' }}
          >
            <FormattedMessage id="ForProvidersHero.signUp" defaultMessage="Start your profile" />
          </NamedLink>
        </div>
      </div>
      <ul className={css.list}>
        {points.map(point => (
          <li key={point.id} className={css.item}>
            <svg className={css.mark} viewBox="0 0 20 20" aria-hidden="true">
              <path
                d="M4.5 10.5 8.2 14.2 15.5 6"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <FormattedMessage id={point.id} defaultMessage={point.defaultMessage} />
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Hero;
